import React from 'react';
import { RowItem, RowItemCompact } from './components';
const PlanRowItem = ({
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | nu... Remove this comment to see the full error message
  text = null,
  isCompact = false,
  loading = false,
  contentType = 'icon-check',
}) =>
  isCompact ? (
    <RowItemCompact text={text} contentType={contentType} />
  ) : (
    <RowItem text={text} contentType={contentType} loading={loading} />
  );

export default PlanRowItem;
